module.exports = __webpack_public_path__ + "img/20.abd32bd4.png";